// Generated by scripts/generate-release-info.mjs during every dev/build invocation.
export const BUILD_INFO = {
  "gitSha": "unknown",
  "checkpointId": "unknown",
  "buildTime": "2026-10-26T06:27:54.594Z"
} as const;
